/* eslint-disable complexity */
import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';
import { INVITATION_STATUS, INVITATION_STATUS_COLOR } from '../../../../utils/constant';
import { Icon } from 'front-onceforall-core';
import { Tooltip } from '@material-ui/core';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const InvitationView = props => {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: props.invitation.status === INVITATION_STATUS.PENDING && /*#__PURE__*/_jsxs("div", {
      className: "box border bottom m-0",
      children: [/*#__PURE__*/_jsx("div", {
        className: "card-header",
        children: /*#__PURE__*/_jsxs("div", {
          className: "font-size-xl",
          children: [/*#__PURE__*/_jsx("div", {
            className: "inline-container",
            children: props.position
          }), "\xA0", '/', "\xA0", /*#__PURE__*/_jsx(Translate, {
            color: INVITATION_STATUS_COLOR.PENDING,
            value: `project.invite.${props.invitation.status}.${props.invitation.role}`,
            level: props.invitation.roleLevel,
            dangerousHTML: true
          }), /*#__PURE__*/_jsx(Tooltip, {
            "data-id": "invitation-pending-tooltip",
            title: /*#__PURE__*/_jsx(Translate, {
              value: "project.invite.PENDING.tooltip",
              firstName: props.invitation.firstName,
              lastName: props.invitation.lastName,
              email: props.invitation.email
            }),
            children: /*#__PURE__*/_jsx("span", {
              className: "info",
              style: {
                marginLeft: '5px'
              },
              children: /*#__PURE__*/_jsx(Icon, {
                icon: "info"
              })
            })
          })]
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex-column",
        style: {
          paddingLeft: 'calc(100% / 25)'
        },
        children: [/*#__PURE__*/_jsx("b", {
          className: "font-size-xl",
          children: props.invitation.organisationName
        }), /*#__PURE__*/_jsx("div", {
          className: "information",
          children: props.invitation.registrationNumber
        })]
      })]
    })
  });
};
InvitationView.propTypes = {
  invitation: PropTypes.shape({
    status: PropTypes.string.isRequired,
    organisationName: PropTypes.string,
    role: PropTypes.string,
    roleLevel: PropTypes.number,
    registrationNumber: PropTypes.string,
    email: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string
  }),
  position: PropTypes.number.isRequired
};
export default InvitationView;